<script>
  import { filteredAccounts, search } from '../store.js';
  import { AppController } from '../AppController'
  import DeleteAccountModal from './DeleteAccountModal.svelte';
  import Pagination from './Pagination.svelte';
  import { LoginService } from '../services/login-service';

  let accountToDelete;

  let displayAccounts = [];

  const showDeleteModal = (account) => {
    accountToDelete = account;
    AppController.displayDeleteAccountModal(true);
  }

  const actAs = (account) => {
    search.set('');
    LoginService.signOut(account.email, account.password);
  }

  const paginate = (event) => {
    displayAccounts = event.detail.items;
  }
</script>
<div class="row">
  <div class="col-md-12 stretch-card">
    <div class="card">
      <div class="card-body">
        <p class="card-title">Customers</p>
        <div class="table-responsive">
          <table id="residents" class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Company</th>
                <th>Contact</th>
                <th>City</th>
                <th>Email</th>
                <th class='text-center'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {#each displayAccounts as account}
                <tr>
                  <td>{account.company}</td>
                  <td>{account.first_name} {account.last_name}</td>
                  <td>{account.city}</td>
                  <td>{account.email}</td>
                  <td class='text-center'>
                    <a href='#/admin/account/{account.account_id}' title='edit'>
                      <i class="mdi mdi-account-edit icon-md mr-3 text-primary"></i>
                    </a>
                    <a on:click|preventDefault={()=> showDeleteModal(account)} href='#' title='delete'>
                      <i class="mdi mdi-account-minus icon-md mr-3 text-danger"></i>
                    </a>
                    <a on:click|preventDefault={()=> actAs(account)} href='#' title='login as'>
                      <i class="mdi mdi-account-arrow-right icon-md mr-3 text-primary"></i>
                    </a>
                  </td>
                </tr>
              {/each}
            </tbody>
            <tfoot>
              <tr>
                <td colspan='5'>
                  <nav class='mt-2' aria-label="Page navigation">
                    <Pagination items={$filteredAccounts} on:paginate={paginate}></Pagination>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<DeleteAccountModal account={accountToDelete} on:delete></DeleteAccountModal>